class SubscribeForm {
  constructor ($el) {
    const $formContainner = $el.find('.subscribe-form-container')
    if ($formContainner) {
      window.fd('form', {
        formId: '64837a84fbd770b7b2026244',
        containerEl: '#fd-form-64837a84fbd770b7b2026244',
      })
    }
  }
}

export default SubscribeForm



// WEBPACK FOOTER //
// ./scripts/components/SubscribeForm.js